import { Response } from './response'

export class Question {


    constructor(id: number, subscribeToQuestions: number[], text: string, description: string, type: string, responses: Array<Response>, shuffle: boolean, layout: 'horizontal' | 'vertical' = 'horizontal', warning?: any, type_id_checkbox?: 1 | 2, has_logo?: boolean, footer?: string, lockDisabled?: boolean, mobileDisplay?: boolean, image?: string, imagePosition: 'before' | 'after' = 'after' // <-- Adăugat
    ) {
        this.id = id;
        this.subscribeToQuestions = subscribeToQuestions
        this.text = text;
        this.description = description;
        this.type = type;
        this.responses = responses;
        this.shuffle = shuffle;
        this.layout = layout;
        this.warning = warning;
        this.type_id_checkbox = type_id_checkbox; // am pus pentru ca aveam nevoie sa disting intrebarile care contineau imagini/aveam imagini care aveau nevoie de redimensionare si am definit clase diferite, deci aveam nevoie de ceva sa pot sa le disting
        this.isDisable = false;
        this.isDisabledText = false;
        this.has_logo = has_logo;
        this.footer = footer;
        this.lockDisabled = lockDisabled;
        this.mobileDisplay = mobileDisplay;
        this.image = image;
        this.imagePosition = imagePosition;

        if (this.shuffle) {
            let rightBoundary = (this.type === 'checkbox-free' || this.type === 'checkbox' ? (this.responses.length - 2) : (this.responses.length - 1));
            for (let i = rightBoundary - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.responses[i], this.responses[j]] = [this.responses[j], this.responses[i]];
            }
        }
    }

    id: number;
    subscribeToQuestions: number[];
    text: string;
    description: string;
    type: string;
    responses: Array<Response>;
    shuffle: boolean;
    selected: number = 0;
    layout: 'horizontal' | 'vertical';
    warning?: any;
    type_id_checkbox?: 1 | 2 = 1;
    isDisable?: boolean;
    isDisabledText?: boolean;
    has_logo?: boolean;
    footer?: string;
    lockDisabled?: boolean;
    mobileDisplay?: boolean;
    image?: string;
    imagePosition: 'before' | 'after';


    render(): boolean {
        return true;
    }

    renderResponse() {
        return this.responses.filter(r => r.render(r));
    }


}